import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ApiIntegration } from '../../_services/api.integration';
import { AlertService } from '../../_services/alert.service';


@Component({
  selector: 'app-cod-data',
  templateUrl: './cod-data.component.html',
  styleUrls: ['./cod-data.component.scss'],
})
export class CodDataComponent implements OnInit {
  public select: string = 'N';
  productImage: string = "";
  uploadPopup: string = "";
  statusText2: string = "";
  uploadDismissModal: string = "";
  popUpAlertSuccessTitle: any;
  popUpAlertSuccessMessage: any;
  popUpAlertErrorMessage: any;
  popUpAlertErrorTitle: any;
  carriers: string;
  carriersList = [];

  constructor(private http: HttpClient, private api: ApiIntegration, public g: Globals, private alertService: AlertService) {
    this.carriersList = [
      { label: 'Bluedart', config: 'Bluedart' },
      { label: 'FedEx', config: 'FedEx' },
      { label: 'Gati', config: 'Gati' },
      { label: 'Delhivery', config: 'Delhivery' },
      { label: 'ShadowFox', config: 'ShadowFox' },
      { label: 'DotZot', config: 'DotZot' },
      { label: 'Expressbees', config: 'Expressbees' },
      { label: 'Kerry', config: 'Kerry' }
    ];
  }

  ngOnInit() {
  }

  openPopUp() {
    this.select = 'Y';
  }


  getFileName(fileupload): string {
    var filename = fileupload.replace(/^.*[\\\/]/, "");
    return filename;
  }

  loadorder(event) {

    this.productImage = event.target.files[0];
  }

  removeFile() {
    this.productImage = "";
  }

  submitImportOrder() {
    this.g.loaderDisplay = "display";
    this.uploadDismissModal = "modal";
    this.uploadPopup = "#myModalOne";
    const file = this.productImage;

    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadCodFileData', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.alertService.success('Data', 'Uploaded Successfully');
        this.uploadPopup = "";
      } else if (data['code'] == 400) {
        this.uploadDismissModal = "";

        this.uploadPopup = "#";
        return false;
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.uploadDismissModal = "";
        this.uploadPopup = "#";
      });
  }

}
